import { getField, updateField } from "vuex-map-fields";

import API from "@/api";

export const state = () => ({
  // table
  jobs: [],
  loadingTable: false,
  // filtros
  textSearchJob: null,
  searchJob: [],
  jobMap: {},
  selectedSearchFonte: null,
  selectedDtRequest: [],
  selectedSearchStatus: null,

  // combo
  searchAcionamentos: [],

  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  currentPage: 1,
});

export const getters = {
  getField,
  formatAcionamento: (state) => (code) => formatAcionamento(state, code),
};

function formatAcionamento(state, enumCode) {
  if (
    Object.keys(state.acionamentoMap).length === 0 ||
    !state.acionamentoMap[enumCode]
  ) {
    return enumCode;
  } else {
    return state.acionamentoMap[enumCode];
  }
}

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);
  config.params.append("sort", "dsJob");

  if (state.textSearchJob) {
    config.params.append("dsJob", state.textSearchJob);
  }
  if (state.selectedSearchFonte) {
    config.params.append("dsFonte", state.selectedSearchFonte.toString());
  }

  if (state.selectedSearchStatus) {
    config.params.append("dsStatusJob", state.selectedSearchStatus.toString());
  }

  if (state.selectedDtRequest) {
    if (state.selectedDtRequest.length === 1) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
    } else if (state.selectedDtRequest.length === 2) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
      config.params.append("dtFimExec", state.selectedDtRequest[1]);
    }
  }

  return config;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });
    // commit("updateField", { path: "loadingTable", value: true });
    commit("updateField", { path: "jobs", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });
    // commit("updateField", { path: "totalPages", value: 0 });

    const result = await API.axios.get(
      "/bff/api/v1/rotinas",
      mountSearchPayload(state)
    );
    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      commit("updateField", { path: "jobs", value: result.data.content });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/rotinas",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      commit("updateField", { path: "jobs", value: result.data.content });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getAcionamentos({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(`/bff/api/v1/rotinas/acionamento/list`);
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", { path: "searchAcionamentos", value: result.data });
      commit("updateField", {
        path: "acionamentoMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },

  async updateAcionamentoConfig({ dispatch, state }, { dsJob, jobForm }) {
    const response = await API.axios.patch(
      `/bff/api/v1/rotinas/${dsJob}`,
      jobForm
    );
    return response;
  },

  async updateNotificacaoWebHook(
    { dispatch, state },
    { dsJob, notificacaoForm }
  ) {
    const response = await API.axios.put(
      `/bff/api/v1/rotinas/${dsJob}/notificacoes-webhook/${notificacaoForm.idNotificacaoWebhook}`,
      notificacaoForm
    );
    return response;
  },

  async insertNewWebHook({ dispatch, state }, { dsJob, notificacaoForm }) {
    const response = await API.axios.post(
      `/bff/api/v1/rotinas/${dsJob}/notificacoes-webhook`,
      notificacaoForm
    );
    return response;
  },

  async createJob({ dispatch, state }, { jobForm }) {
    const response = await API.axios.post(`/bff/api/v1/rotinas`, jobForm);
    return response;
  },

  async deleteNotificacaoWebHook(
    { dispatch, state },
    { dsJob, idNotificacaoWebhook }
  ) {
    const response = await API.axios.delete(
      `/bff/api/v1/rotinas/${dsJob}/notificacoes-webhook/${idNotificacaoWebhook}`,
      idNotificacaoWebhook
    );
    return response;
  },

  async deleteJob({ dispatch, state }, dsJob) {
    const response = await API.axios.delete(`/bff/api/v1/rotinas/${dsJob}`);
    return response;
  },

  async getRotinasList({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(`/bff/api/v1/rotinas/list`);

    if (result.status === 200) {
      commit("updateField", {
        path: "searchJob",
        value: result.data,
      });
    }
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
};

function objectToMap(status) {
  let map = {};
  status.forEach((elem) => {
    map[elem.code] = elem.label;
  });
  return map;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
